<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-01-15 14:31:29
 * @LastEditTime: 2021-03-03 10:57:01
-->
<template>
  <div id="problem">
    <section class="search">
      <el-form :inline="true" class="search-form">
        <el-form-item label="包名">
          <el-select
            v-model="form.pkg"
            multiple
            collapse-tags
            style="width: 300px"
            placeholder="请选择（默认所有）"
          >
            <el-option
              v-for="item in optionsPkg"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="操作系统">
          <el-select
            v-model="form.os"
            multiple
            collapse-tags
            style="width: 200px"
            placeholder="请选择（默认所有）"
          >
            <el-option
              v-for="item in optionsOs"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="用户名">
          <el-input v-model="form.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="问题">
          <el-select
            v-model="form.question"
            multiple
            collapse-tags
            style="width: 200px"
            placeholder="请选择（默认所有）"
          >
            <el-option
              v-for="item in optionsQue"
              :key="item.pk"
              :label="item.name"
              :value="item.pk"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="form.date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期(默认七天)"
            end-placeholder="结束日期(默认七天)"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" icon="el-icon-search"
            >搜索</el-button
          >
          <el-button type="primary" @click="reset" icon="el-icon-refresh-right"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </section>
    <div class="table-wrap">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="组别">
                <span>{{ props.row.pkg__group }}</span>
              </el-form-item>
              <el-form-item label="包名">
                <span>{{ props.row.pkg__pkg }}</span>
              </el-form-item>
              <el-form-item label="操作系统">
                <span>{{ props.row.pkg__os }}</span>
              </el-form-item>
              <el-form-item label="版本">
                <span>{{ props.row.ver }}</span>
              </el-form-item>
              <el-form-item label="设备">
                <span>{{ props.row.dev_mode }}</span>
              </el-form-item>
              <el-form-item label="反馈用户">
                <span>{{ props.row.u_name }}</span>
              </el-form-item>
              <el-form-item label="问题">
                <span>{{ props.row.cus_issue__name }}</span>
              </el-form-item>
              <el-form-item label="详细描述">
                <span>{{ props.row.server_desc }}</span>
              </el-form-item>
              <el-form-item label="当前国家">
                <span>{{ props.row.ctr }}</span>
              </el-form-item>
              <el-form-item label="ip">
                <span>{{ props.row.ip }}</span>
              </el-form-item>
              <el-form-item label="系统语言">
                <span>{{ props.row.os_lang }}</span>
              </el-form-item>
              <el-form-item label="设备国家">
                <span>{{ props.row.s_ctr }}</span>
              </el-form-item>
              <el-form-item label="用户等级">
                <span>{{ props.row.u_level }}</span>
              </el-form-item>
              <el-form-item label="用户名称">
                <span>{{ props.row.u_name }}</span>
              </el-form-item>
              <el-form-item label="系统版本">
                <span>{{ props.row.ver }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="pkg__group"
          label="组别"
          width="100"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="create_time"
          label="归档时间"
          width="200"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="pkg__pkg"
          label="包名"
          width="200"
        >
        </el-table-column>
        <el-table-column align="center" label="操作系统">
          <template slot-scope="scope">
            <span>{{ scope.row.pkg__os === 1 ? "Android" : "Ios" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="ver" label="版本">
        </el-table-column>
        <el-table-column align="center" prop="u_name" label="反馈用户">
        </el-table-column>
        <el-table-column
          align="center"
          prop="cus_issue__name"
          label="问题"
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="server_desc"
          label="详细描述"
          width="180"
        >
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="openDrawer(scope.row)" type="text" size="small"
              >查看聊天</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="toSolveProblem(scope.row)"
              >处理问题</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="关闭问题" :visible.sync="dialogVisible" width="30%">
      <el-input
        type="textarea"
        :rows="6"
        placeholder="请输入关闭的描述"
        v-model="textarea"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeProblem">确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer
      title="聊天会话"
      size="40%"
      :visible.sync="drawerVisib"
      :with-header="false"
    >
      <div class="chat-wrap">
        <virtual-list
          ref="vsl"
          class="interface"
          :data-key="'ts'"
          :data-sources="curChatData"
          :data-component="chatContentComponent"
        >
          <!-- <div slot="header" class="loading-footer" v-show="overflowHeader">
          <div class="spinner" v-show="!finishedHeader">
            <i class="el-icon-loading"></i>
          </div>
          <div class="finished" v-show="finishedHeader">已经到顶了</div>
        </div> -->
        </virtual-list>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getSolveList, toSolve } from "../../api/develop";
import { fileType } from "../../utils/index";
import chatContent from "./chat";
import VirtualList from "vue-virtual-scroll-list";
export default {
  components: {
    chatContent,
    "virtual-list": VirtualList,
  },
  data() {
    return {
      loading: false,
      chatContentComponent: chatContent,
      tableData: [],
      drawerVisib: false,
      dialogVisible: false,
      curChatData: [],
      textarea: "",
      curPk: -1,
      form: {
        date: "",
        pkg: [],
        // os: [],
        name: "",
        question: [],
      },
      optionsPkg: [],
      optionsOs: [
        {
          value: 0,
          label: "Ios",
        },
        {
          value: 1,
          label: "Android",
        },
      ],
      optionsQue: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getData();

    let _group = JSON.parse(localStorage.getItem("pkg"));
    let resList = [];
    _group.forEach((gVal) => {
      resList.push({
        value: gVal.pkg,
        label: gVal.pkg,
      });
    });
    this.optionsPkg = resList;

    this.optionsQue = JSON.parse(localStorage.getItem("issue"));
  },
  methods: {
    openDrawer(val) {
      this.drawerVisib = true;
      if (val.info) {
        val.info.forEach((item, index) => {
          fileType(item.msg, val.user, item.ts, val.pkg__pkg, item);
        });
      }
      this.curChatData = val.info;
    },
    toSolveProblem(val) {
      this.curPk = val.pk;
      this.dialogVisible = true;
    },
    closeProblem() {
      let params = {
        pk: this.curPk,
        desc: this.textarea,
      };
      toSolve(params).then((res) => {
        this.dialogVisible = false;
        let ind;
        this.tableData.forEach((item, index) => {
          if (item.pk === this.curPk) {
            ind = index;
          }
        });
        this.tableData.splice(ind, 1);
        this.$message({
          message: "处理成功",
          type: "success",
        });
      });
    },

    onSubmit() {
      let st = this.form.date ? this.form.date[0] : "";
      let et = this.form.date ? this.form.date[1] : "";
      let params = {
        pkg: this.form.pkg.join(","),
        u: this.form.name,
        cus_issue: this.form.question.join(","),
        st,
        et,
      };

      this.loading = true;

      getSolveList(params)
        .then((res) => {
          res.forEach((item) => {
            item.getT = new Date(item.create_time).getTime();
          });
          res.sort((a, b) => {
            return b.getT - a.getT;
          });
          this.tableData = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getData() {
      this.loading = true;
      getSolveList()
        .then((res) => {
          res.forEach((item) => {
            item.getT = new Date(item.create_time).getTime();
          });
          res.sort((a, b) => {
            return b.getT - a.getT;
          });
          this.tableData = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    reset() {
      this.form.pkg = [];
      this.form.name = "";
      this.form.question = [];
      this.form.date = "";
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#problem {
  width: 100%;
  height: 100%;
  padding: 40px;
}
.table-wrap {
  margin-top: 20px;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.chat-wrap {
  height: 100%;
  //   padding: 0 20px;
}
.interface {
  position: relative;
  width: 100%;
  height: 100%;
  border-bottom: none;
  overflow-y: auto;
}

.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>